<template>
	<div>
		<select
			v-if="input.type == 'select'"
			v-model="input.value"
			class="form-control"
			:disabled="input.disabled"
		>
			<option
				v-for="(opt, index) in input.options.options"
				:key="index"
				:value="opt.value"
			>
				{{ opt.text }}
			</option>
		</select>
	</div>
</template>
<script>
	// import tools from "../../../../functions/functions.js"
	export default {
		name: 'ChSelect',
		props: ['data'],
		computed: {
			input() {
				return this.data;
			},
		},
		watch: {
			'input.options': function (data) {
				//console.log("watch", this.input.type, data.type)
				if (data.type == 'table-db') {
					const sData = {
						id: 'load-options-data',
						table: data.inTable,
					};
					// tools.send("action-sistem", sData, (rDate) => {
					// 	this.$set(this.input.options, "options", rDate)
					// }, "json")
				}
			},
		},
		mounted() {
			//console.log("mounted", this.input.type)
			if (
				this.input.type == 'select' &&
				this.input.options.type == 'table-db'
			) {
				const sData = {
					id: 'load-options-data',
					table: this.input.options.inTable,
				};
				// tools.send("action-sistem", sData, (rDate) => {
				// 	this.$set(this.input.options, "options", rDate)
				// 	//console.log(rDate)
				// }, "json")
			}
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/models/create-form/inputs/chSelect.vue